<div class="drawer" @drawerAnim>
  @if (vm$ | async; as vm) {
    <nav class="drawer__nav">
      @for (item of vm.items; track trackByRoute($index, item)) {
        <button class="drawer__link" [routerLink]="item.route" routerLinkActive="active" (click)="close.emit()">
          <img [src]="'assets/icons/menu/' + item.icon + '.svg'" [alt]="item.label" />
          {{ item.label }}
        </button>
      }
    </nav>

    <hr class="drawer__divider" />

    <div class="drawer__footer">
      @if (vm.isAuth) {
        <button class="drawer__logout" (click)="logout()">
          <span>Logout</span>
          <img src="assets/icons/logout.svg" alt="Logout" />
        </button>
      }
    </div>
  }
</div>
